import { uiText, useUiLanguage } from '../../../../../utils/uiTranslation';
import React, { useEffect, useRef, useState } from 'react';

const RecruitmentFilterBar = ({
  filters,
  actions,
  onAction,
  onFilterChange,
  isRTL = false
}) => {
  useUiLanguage();
  const [openFilterId, setOpenFilterId] = useState(null);
  const filterBarRef = useRef(null);
  const hasActions = Array.isArray(actions) && actions.length > 0;

  useEffect(() => {
    const handlePointerDown = (event) => {
      if (filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenFilterId(null);
      }
    };

    document.addEventListener('mousedown', handlePointerDown);
    return () => document.removeEventListener('mousedown', handlePointerDown);
  }, []);

  return (
    <div
      ref={filterBarRef}
      className={`analytics-recruitment-filterbar${isRTL ? ' rtl' : ''}${hasActions ? ' has-actions' : ' no-actions'}`}
    >
      <div className="analytics-recruitment-filter-strip">
        {filters.map((filter) => (
          <div key={filter.id} className="analytics-recruitment-filter-control">
            <button
              type="button"
              className={`analytics-recruitment-filter-button${openFilterId === filter.id ? ' open' : ''}`}
              onClick={() => setOpenFilterId((current) => (current === filter.id ? null : filter.id))}
            >
              <span className="analytics-recruitment-filter-label">{uiText(filter.label)}</span>
              <span className="analytics-recruitment-filter-separator" aria-hidden="true">·</span>
              <span className="analytics-recruitment-filter-value">{filter.value}</span>
              <i className="fa-solid fa-chevron-down analytics-recruitment-filter-icon" />
            </button>

            {Array.isArray(filter.options) && filter.options.length ? (
              <div className={`analytics-recruitment-filter-menu${openFilterId === filter.id ? ' open' : ''}${isRTL ? ' rtl' : ''}`}>
                {filter.options.map((option) => (
                  <button
                    key={option.id}
                    type="button"
                    className={`analytics-recruitment-widget-menu-item${
                      (filter.isMulti ? filter.selectedIds?.includes(option.id) : filter.selectedId === option.id) ? ' active' : ''
                    }`}
                    onClick={() => {
                      if (filter.isMulti) {
                        const currentIds = Array.isArray(filter.selectedIds) ? filter.selectedIds : [];
                        let nextValue = 'all';

                        if (option.id === 'all') {
                          nextValue = 'all';
                        } else {
                          const nextIds = currentIds.includes(option.id)
                            ? currentIds.filter((id) => id !== option.id)
                            : [...currentIds, option.id];
                          nextValue = nextIds.length ? nextIds : 'all';
                        }

                        onFilterChange?.(filter.id, nextValue);
                        return;
                      }

                      onFilterChange?.(filter.id, option.id);
                      setOpenFilterId(null);
                    }}
                  >
                    {uiText(option.label)}
                  </button>
                ))}
              </div>
            ) : null}
          </div>
        ))}
      </div>

      {actions?.length ? (
        <div className="analytics-recruitment-filter-actions">
          {actions.map((action) => (
            <button
              key={action.id || action.label}
              type="button"
              className={`analytics-recruitment-action-button ${action.tone || 'ghost'}`}
              onClick={() => onAction?.(action.id)}
            >
              {action.icon ? <i className={`fa-solid ${action.icon}`} /> : null}
              <span>{uiText(action.label)}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default RecruitmentFilterBar;
